import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["menu", "subCategory"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isString from 'lodash/isString';
import { DEFAULT_SEO_TYPE, SUB_CATEGORY_TO_SEO_TYPE } from './LocalBusinessSchema.constants';
import { getImageSrc } from '../../../../utils/images';
import formatAddress from '../transformers/address';
import { getImage } from '../utils/image';
export function getFirstIfArray(object) {
  if (_isNil(object)) {
    return null;
  }
  if (!_isArray(object)) {
    return object;
  }
  if (!_isEmpty(object)) {
    return object[0];
  }
  return null;
}
export function addIfNotEmpty(object, key, value) {
  if (!_isNil(value) && !_isEmpty(value)) {
    return _objectSpread(_objectSpread({}, object), {}, _defineProperty({}, key, value));
  }
  return object;
}
export function generateOrganizationSchema(name) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SEO_TYPE;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    url = _ref.url,
    images = _ref.images,
    logo = _ref.logo,
    address = _ref.address;
  var schema = {
    '@context': 'https://schema.org',
    '@type': type,
    name: name
  };
  var imageSrc = getImageSrc(getImage(images));
  var formattedAddress = formatAddress(address);
  schema = addIfNotEmpty(schema, 'url', url);
  schema = addIfNotEmpty(schema, 'logo', logo);
  if (_isString(imageSrc)) {
    schema = addIfNotEmpty(schema, 'image', imageSrc);
  }
  return addIfNotEmpty(schema, 'address', formattedAddress);
}
export function generateFoodEstablishmentSchema(name, type) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    menu = _ref2.menu,
    subCategory = _ref2.subCategory,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var schema = generateOrganizationSchema(name, type, _objectSpread({}, rest));
  return addIfNotEmpty(schema, 'servesCuisine', subCategory);
}
export function getTypeForCategory() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$fallback = _ref3.fallback,
    fallback = _ref3$fallback === void 0 ? DEFAULT_SEO_TYPE : _ref3$fallback;
  if (_isEmpty(category)) {
    return fallback;
  }
  return SUB_CATEGORY_TO_SEO_TYPE[category.toLowerCase()] || fallback;
}
export function getSchemaGeneratorFunction() {
  var category = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var functionByCategory = {
    rest: generateFoodEstablishmentSchema
  };
  return functionByCategory[category.toLowerCase()] || generateOrganizationSchema;
}